import type { BookingWithSlotItem } from '../widget-api/bookings';
import { mergeWidgetQueryString } from './merge-widget-query';
import { PATH } from './path-routes';

export function findActiveBookingForSlot(
  bookings: BookingWithSlotItem[] | null | undefined,
  slotId: number
): BookingWithSlotItem | null {
  if (!bookings?.length || !Number.isFinite(slotId) || slotId < 1) return null;
  return bookings.find((booking) => booking.slot_id === slotId && booking.status !== 'cancelled') ?? null;
}

export function bookingNeedsPayment(booking: BookingWithSlotItem | null | undefined): boolean {
  if (!booking || booking.status === 'cancelled') return false;
  return Boolean(booking.service_payment_required && !booking.payment_received);
}

type SlotPaymentFields = {
  service_payment_required?: boolean | null;
  service_price?: number | null;
};

/**
 * Нужен ли платёжный шаг для слота: услуга требует оплату и цена больше нуля.
 * Если поле service_payment_required отсутствует (старый API) — fallback на цену.
 */
export function slotNeedsPayment(slot: SlotPaymentFields | null | undefined): boolean {
  if (!slot || slot.service_payment_required === false) return false;
  return slot.service_price != null && slot.service_price > 0;
}

export function buildBookingsPayRedirect(
  currentSearchWithoutQuestion: string,
  bookingId: number
): string {
  return `${PATH.bookings}${mergeWidgetQueryString(currentSearchWithoutQuestion, {
    booking_id: String(bookingId),
    pay: '1',
  })}`;
}
